export default "__VITE_ASSET__C1dKi8G6__"